import { getSupportedExtensions } from "@/store/features/bulkResize/utils/getSupportedExtensions";
import { useGoogleDriveUpload } from "client/hooks/upload/useGoogleDriveUpload";
import { List } from "components/common/List/List";
import { DeviceUpload } from "components/common/Upload/DeviceUpload/DeviceUpload";
import { DropboxUpload } from "components/common/Upload/DropboxUpload/DropboxUpload";
import { GoogleDriveAccessErrorModal } from "components/common/Upload/GoogleDriveUpload/GoogleDriveAccessErrorModal/GoogleDriveAccessErrorModal";
import { GoogleDriveUpload } from "components/common/Upload/GoogleDriveUpload/GoogleDriveUpload";
import { UrlUpload } from "components/common/Upload/UrlUpload/UrlUpload";
import { useRouter } from "next/router";
import { BULK_RESIZE_DEVICE_INPUT_ID } from "../../../ControlBar/AddImages/AddImages";
import { useAddImages } from "../../../ControlBar/AddImages/useAddImages";

export interface AddImageProps {
    isOpen: boolean;
    handleClose: () => void;
}

export const AddImage = ({ isOpen, handleClose }: AddImageProps) => {
    const { handleFile } = useAddImages(handleClose);
    const router = useRouter();
    const supportedExtensions = getSupportedExtensions(router.pathname);
    const {
        handleClick: handleGoogleDriveUploadClick,
        accessError,
        setAccessError,
        isLoading: isGoogleDriveLoading,
    } = useGoogleDriveUpload(handleFile, { allowMultiple: true, supportedExtensions }, isOpen);

    return (
        <div className="flex flex-col gap-3 py-2 font-xl dark:bg-darkSurface-200 dark:border dark:border-darkSurface-400 text-black dark:text-white rounded-lg">
            <List
                items={{
                    from_device: (
                        <DeviceUpload
                            handleFile={handleFile}
                            options={{ allowMultiple: true, supportedExtensions }}
                            htmlFileInputId={BULK_RESIZE_DEVICE_INPUT_ID + router.asPath}
                        />
                    ),
                    dropbox: (
                        <DropboxUpload
                            handleFile={handleFile}
                            options={{ allowMultiple: true, supportedExtensions }}
                            isOpen={isOpen}
                        />
                    ),
                    google_drive: (
                        <GoogleDriveUpload
                            options={{
                                allowMultiple: true,
                                onClick: handleGoogleDriveUploadClick,
                                supportedExtensions,
                            }}
                            isLoading={isGoogleDriveLoading}
                        />
                    ),
                    url_upload: <UrlUpload handleFile={handleFile} options={{ supportedExtensions }} />,
                }}
            />
            <GoogleDriveAccessErrorModal
                isOpen={accessError}
                close={() => setAccessError(false)}
                handleRetry={handleGoogleDriveUploadClick}
            />
        </div>
    );
};
